import React from 'react'
import { StyleSheet, View, ViewProps } from 'react-native'
import { DS } from '@/design-system'

type SettingsCardProps = {
  children: React.ReactNode
  gap?: number
  style?: ViewProps['style']
}

export function SettingsCard({ children, gap = 16, style }: SettingsCardProps) {
  return <View style={[styles.card, { gap }, style]}>{children}</View>
}

const styles = StyleSheet.create({
  card: {
    backgroundColor: DS.palette['Global/White'],
    borderRadius: 24,
    padding: 20,
    borderWidth: 1,
    borderColor: DS.palette['Brand/Light Grey']
  }
})
